//Product quantities keep up to 3 decimals, as dm-mo-calculate-final-price does:
//a 13.608 kg box is 13.608 / 27.216 / 40.824 and a 0.125 kg step stays 0.375.
//Integers and quantities with up to 2 decimals come back unchanged.
export const QUANTITY_DECIMALS = 3;

export function roundQuantity(value: any): number {
  return parseFloat(parseFloat(value).toFixed(QUANTITY_DECIMALS));
}

//The 2-decimal text the app has always shown ("0.50", "1.00"), with a third
//decimal only when the quantity really has one ("0.375").
export function quantityText(value: any): string {
  const rounded = roundQuantity(value);
  const twoDecimals = rounded.toFixed(2);

  return parseFloat(twoDecimals) === rounded
    ? twoDecimals
    : rounded.toFixed(QUANTITY_DECIMALS);
}
